import PickupCategoryIndex from './PickupCategoryIndex';
import PickupCategoryCreate from './PickupCategoryCreate';
import PickupCategorySettings from './PickupCategorySettings';
import PickupCategorySingle from './PickupCategorySingle';

export default function (app) {

    const settings = PickupCategorySettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 9,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    PickupCategoryIndex(app, settings);

    PickupCategoryCreate(app, settings);

    PickupCategorySingle(app, settings);

}